import { apiCustomer } from '@/api'
import verifyUserInCart from '@/lib/verify-user-in-cart'
import { Address } from '@/types'

async function createAddress(formData: Omit<Address, "id">) {
  await verifyUserInCart()

  return apiCustomer.post<Address[]>("/addresses", formData)
    .then(response => response.data)
    .catch(() => {
      throw new Error("something went wrong creating address")
    })
}

export default createAddress
